// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;If they come to see me, they utter empty words;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;their heart gathers mischief;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;when they go out, they tell it abroad.<br> </p> </div></div>";
// Exports
module.exports = code;